import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import {withStyles} from "@material-ui/core/styles";
import {FS_LOGIN_FACEBOOK, FS_LOGIN_GOOGLE} from "../../ducks/duck-user";
import {getTranslation} from "../../helpers/get-translation";


const styles = theme => ({
	root:{},
	testButton: {
		backgroundColor: "#3598d9",
		"&:hover": {
			backgroundColor: "#2d76d9"
		}
	},
	anonymousButton: {
		backgroundColor: "#abc1d9",
		"&:hover": {
			backgroundColor: "#71849c"
		}
	},
	goggleButton: {
		backgroundColor: "#fff",
		"&:hover": {
			backgroundColor: "#ccc"
		}
	},
	facebookButton: {
		backgroundColor: "#30518a",
		color: 'white',
		"&:hover": {
			backgroundColor: "#213e71"
		}
	},
});

function SocialButtons(props) {
	const { classes,
		fsLoginUserSocial } = props;

	return (
		<div>
			{/*Zaloguj Google*/}
			<Button
				variant="contained"
				className={classes.goggleButton}
				onClick={() => fsLoginUserSocial(FS_LOGIN_GOOGLE)}
			>
				<div>
					<img src='static/images/login-screen/google.svg'/>
					<span>{getTranslation("login_google")}</span>
				</div>

			</Button>

			{/*Zaloguj Facebook*/}

			<Button
				variant="contained"
				className={classes.facebookButton}
				onClick={() => fsLoginUserSocial(FS_LOGIN_FACEBOOK)}
			>
				<div>
					<img src='static/images/login-screen/facebook.svg'/>
					<span>{getTranslation("login_facebook")}</span>
				</div>

			</Button>

		</div>
	)
}

SocialButtons.propTypes = {
	booleans: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		testButton: PropTypes.string.isRequired,
		anonymousButton: PropTypes.string.isRequired,
		goggleButton: PropTypes.string.isRequired,
	}).isRequired,

	fsLoginUserSocial: PropTypes.func.isRequired,
};

export default withStyles(styles)(SocialButtons);